import axios from 'axios'
import {
  Loading,
  MessageBox
} from 'element-ui'
export default {
  install(Vue, options) {
    // 获取用户信息
    // 跨域安全策略：请求时携带 cookie
    axios.defaults.withCredentials = true
    axios({
      method: 'get',
      url: api + '/getloginuser/getloginuser'
    }).then(res => {
      console.log(res)
      Vue.prototype.userInfo = res.data.data
      Vue.prototype.roleId = res.data.data.roleId
      console.log(res.data.data)
    })
    // 加载框 // 显示loading
    Vue.prototype.showLoading = function () {
      Vue.prototype.Loading = Loading.service({
        lock: true,
        text: '全力加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.1)'
      })
      setTimeout(function () {
        Vue.prototype.closeLoading()
      }, 3000)
    }
    // 关闭 loading
    Vue.prototype.closeLoading = function () {
      Vue.prototype.Loading.close()
    }
    Vue.prototype.alertConfirm = function (content, callback, btnText) {
      MessageBox.confirm(content, '温馨提示', {
          confirmButtonText: btnText ? btnText : '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
        .then(() => {
          callback()
        })
        .catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/config.js